import { createFileRoute, redirect } from "@tanstack/react-router";
import { MaintenanceHelper } from "@/components/MaintenaceHelper/MaintenanceHelper";

export const Route = createFileRoute("/_auth/strategi/vedlikeholdsveileder/$assetGroupName")({
  beforeLoad: () => {
    if (!(import.meta.env.WAI_MAINTENANCEHELPER_ENABLED || import.meta.env.DEV)) {
      throw redirect({ to: "/" });
    }
  },
  component: MaintenanceHelper,
});
